import { render, staticRenderFns } from "./AddNewChapter.vue?vue&type=template&id=7f66d7fb&scoped=true&"
import script from "./AddNewChapter.vue?vue&type=script&lang=js&"
export * from "./AddNewChapter.vue?vue&type=script&lang=js&"
import style0 from "./AddNewChapter.vue?vue&type=style&index=0&id=7f66d7fb&scoped=true&lang=css&"
import style1 from "./AddNewChapter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66d7fb",
  null
  
)

export default component.exports